"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
class Modal {
    constructor() {
        (0, jquery_1.default)(".modal-login-open").on("click", function (e) {
            e.preventDefault();
            (0, jquery_1.default)("#modal-login").fadeIn();
        });
        (0, jquery_1.default)(".modal-login-close").on("click", function () {
            (0, jquery_1.default)("#modal-login").fadeOut();
        });
        (0, jquery_1.default)(".modal-premium-open").on("click", function (e) {
            e.preventDefault();
            (0, jquery_1.default)("#modal-premium").fadeIn();
        });
        (0, jquery_1.default)(".modal-premium-close").on("click", function () {
            (0, jquery_1.default)("#modal-premium").fadeOut();
        });
    }
}
exports.default = Modal;
new Modal();
